import { Context, Effect } from 'effect';
import { GetParticlesError, ParticlesParseError } from './gluon/requests';
import { Particles } from './schema';

export type ParticlesError = GetParticlesError | ParticlesParseError;

export interface _ParticleService {
    getParticles(tenant: string): Effect.Effect<Particles, ParticlesError>;
}

export class ParticleService extends Context.Tag('@fixtuur/backpack/ParticleService')<
    ParticleService,
    _ParticleService
>() {}
